import { Box, Flex } from '@mantine/core'

import classes from '@/modules/accounts/components/AccountsList/AccountsList.module.css'
import { AdvisorAccountItem } from '@/modules/advisors/users/pages/[id]/components/AdvisorAccountItem/AdvisorAccountItem'
import type { AdvisorAccountsListProps } from '@/modules/advisors/users/pages/[id]/components/AdvisorAccountsList/AdvisorAccountsList.types'

export function AdvisorAccountsList({ accounts }: AdvisorAccountsListProps) {
  return (
    <Box className={classes.rightColumn}>
      <Flex className={classes.accountsList}>
        {accounts.map(account => (
          <AdvisorAccountItem key={account.plaidId} account={account} />
        ))}
      </Flex>
    </Box>
  )
}
